import AjaxService from '@services/AjaxService';
import FirmRepository from '@repositories/FirmRepository';
import UrlParameterInterface from '@repositories/UrlParameterInterface';
import BaseRepository, {SelectOption, SelectOptionGroup} from '@repositories/desktop/BaseRepository';

interface FilterInterface {
  property: string,
  value: string,
}

export default class TableComponentRepository extends BaseRepository {
  protected baseUrl = '';
  private readonly firmRepository: FirmRepository;

  public constructor(ajaxService: AjaxService, firmRepository: FirmRepository) {
    super(ajaxService);
    this.firmRepository = firmRepository;
  }

  public getDropdownFactoryOptions<T = number | string>(functionName: string, functionParams?: any): Promise<Array<SelectOption<T>>> {
    const params: UrlParameterInterface = {
      function: functionName,
    }

    if (functionParams) {
      params.functionParams = JSON.stringify(functionParams)
    }

    return this.ajaxService.getJsonWithParameters('/api/desktop/table/options/dropdown-factory', params)
      .then(r => r.data.attributes.options);
  }

  public getTableData(filter: FilterInterface, parameters: UrlParameterInterface, url: string): Promise<any> {
    if (Object.keys(filter).length > 0) {
      // Append filter parameters to URL, using ? or & depending on existing query parameters
      url = url + (url.indexOf('?') != -1 ? '&' : '?') +
        'filter[property]=' + filter.property + '&filter[value]=' + filter.value;
    }

    if (this.firmRepository.getActiveBranch()) {
      url += '&firmId=' + this.firmRepository.getActiveBranch().firmId;
    }
    return this.ajaxService.getJsonWithParameters(url, parameters);
  }
}
